export default __webpack_public_path__ + "assets/qb-logo-horizontal-preferred.png";